// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","532":"styles","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"8be27351b786cdc0b64f","532":"bbac07196c862102af50","691":"38fc2f6c0bdf5bf803d0"}[chunkId] + ".js";
};